<script setup>
import { defineAsyncComponent, ref } from "vue";
import { useParamsStore } from "@/stores/commons/paramsStore";
import { storeToRefs } from "pinia";
import { wcInit } from "@/composables/wcInit";
import { useI18n } from "vue-i18n";
const Hotels = defineAsyncComponent(() => import("@/components/Forms/Hotels.vue")),
  Experience = defineAsyncComponent(() => import("@/components/Forms/Experience.vue")),
  Viaggismart = defineAsyncComponent(() => import("@/components/Forms/Viaggismart.vue"));

const paramsStore = useParamsStore();
const { params } = storeToRefs(paramsStore)
let isActive = true;
if (params.value.client) {
  isActive = false
  const { fetchDisplayData } = wcInit(params.value);
  isActive = await fetchDisplayData(params.value);
}
const { t } = useI18n()


</script>
<template>
  <div>
    <div v-if="isActive">
      <Hotels v-if="params.type === 'hotels'" />
      <Experience v-if="params.type === 'experience'" />
      <Viaggismart v-if="params.type === 'viaggismart'" />
    </div>
    <div v-else>
      <p class="kb-text-center">{{ t('notWorking') }}</p>
    </div>
  </div>
</template>
